<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-27 16:05:16
 * @LastEditTime: 2019-08-11 17:49:04
 * @LastEditors: Please set LastEditors
 -->
<template>
  <el-dialog
    title="申报明细"
    :visible="true"
    :append-to-body="true"
    width="60%"
    :before-close="handleClose"
  >
    <!--表格-->
    <el-table
      ref="multipleTable"
      :data="tableData"
      v-loading="loading"
      height="350"
      border
      stripe
      style="width: 100%"
    >
      <!-- <el-table-column
        v-if="isCodeShow"
        prop="production_batch"
        label="礼品图片"
        width="100"
        height="50"
      >
        <template slot-scope="scope">
          <div class="product_img">
            <img :src="scope.row.img_path + scope.row.gift_img" alt="" />
          </div>
        </template>
      </el-table-column> -->
      <el-table-column
        prop="number"
        label="礼品编号"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="gift_name"
        label="礼品名称"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="applicat"
        width="150"
        label="申报人名称"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="type"
        label="身份类型"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="expense_num"
        label="申报数量"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column prop label="操作" width="150" show-overflow-tooltip fixed="right">
        <template slot-scope="scope">
          <el-button type="primary" @click="confirm(scope.row)">确认报销</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      style="margin: 20px 0"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageNo"
      :page-sizes="[5, 10, 20, 40]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalSize"
    ></el-pagination>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleClose">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "selectDealerExpenseDetail",
  props: {
    detailData: {
      type: String,
      default: " ",
    },
  },
  data() {
    return {
      loading: false,
      form: {
        gift_sn: "",
        gift_name: "",
        gift_batch: "",
        category_id2: "",
      },
      tableData: [],
      //分页
      pageNo: 1,
      pageSize: 5,
      totalSize: 0,
      isCodeShow: true,
      attributesList: [],
      categoryTwo: [],
      categoryOne: [],
    };
  },
  methods: {
    getData() {
      this.loading = true;
      this.$get("logistics2", "/vstore/dealer_pc/lowerExpenseDetail", {
        lang: "",
        salesman_id: this.detailData,
        gift_sn: this.form.gift_sn,
        gift_name: this.form.gift_name,
        gift_batch: this.form.gift_batch,
        gift_category_id: this.form.category_id2,
        per_page: this.pageSize,
        page: this.pageNo,
      })
        .then((res) => {
          this.loading = false;
          this.tableData = res.data.data;
          this.totalSize = res.data.total;
        })
        .catch(function (error) {
          this.loading = false;
          console.log(error);
        });
    },
    /*分页*/
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNo = 1;
      this.getData();
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getData();
    },
    //选择产品
    choose(row) {
      this.$emit("pushData", row);
      this.$emit("handleClose");
    },
    handleClose() {
      this.$emit("handleClose");
    },
    //删除
    confirm(row) {
      this.$confirm("是否确认报销?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$get("logistics_12", "/vstore/dealer_pc/addLowerExpense", {
            product_number: row.number,
            id: this.detailData,
          })
            .then((res) => {
              this.$message({
                type: "success",
                message: "申请报销成功!",
              });
              this.$emit("update-message", this.detailData, row.expense_num);
              this.getData();
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error.message,
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消报销",
          });
        });
    },
  },
  created() {
    // this.getConfigInfo();
    this.getData();
  },
};
</script>
<style lang="scss" scoped>
.product_img {
  height: auto;
  img {
    width: 100%;
  }
}
// /deep/td {
//   height: 100px !important;
//   overflow: visible;
//   .cell {
//     height: 100%;
//     padding-right: 5px;
//   }
// }
</style>
